import React from "react";
import { MessageCircle } from "lucide-react";
import { useSettings } from "../lib/settings";
import { buildWhatsAppMessageUrl } from "../lib/whatsapp";
import { fireGoogleAdsConversion } from "../lib/googleAds";

const StickyWhatsApp = () => {
  const { settings } = useSettings();
  const s = settings || {};

  if (s.show_sticky_whatsapp === false) return null;
  const url = buildWhatsAppMessageUrl(s.whatsapp_number, s.whatsapp_hero_message);
  if (!url) return null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => fireGoogleAdsConversion(s.google_ads_whatsapp_send_to)}
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_24px_rgba(0,0,0,0.25)] hover:scale-105 transition-transform"
    >
      <MessageCircle size={26} fill="white" strokeWidth={0} />
    </a>
  );
};

export default StickyWhatsApp;
